export const logConfiguration = () => {
    const yeDebug = window.localStorage.getItem('yeself-debug') || false;

    let enable;
    if (yeDebug === undefined || yeDebug === null || yeDebug === '') {
        enable = process.env.NODE_ENV !== 'production';
    } else {
        enable = yeDebug === 'true';
    }

    if (!enable || !window.console.debug) {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        console.debug = () => {};
    }

    return {
        debug: enable
    };
};

export const parseJwt = token => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    return JSON.parse(window.atob(base64));
};

/**
 * @return {string}
 */
export const browserLanguage = () => (navigator.language || navigator.userLanguage)?.toLowerCase();

export const isLocalStorageEnabled = () => {
    try {
        localStorage.setItem('yeself-test', 'test');
        localStorage.removeItem('yeself-test');
        return true;
    } catch (e) {
        return false;
    }
};

export const isCookiesEnabled = () => navigator.cookieEnabled;

export const screenRect = () => ({
    height: window.screen.height,
    width: window.screen.width
});

/**
 * Returns value from URL query by its name
 */
export const getQueryValue = param => {
    let value;
    const query = window.decodeURIComponent(window.location.search);
    const index = query.indexOf(param);

    if (index >= 0) {
        let end = query.indexOf('&', index + 1);
        end = end < 0 ? query.length : end;
        value = query.substring(index + param.length + 1, end);
    }

    return value;
};
